export const m = {
  //公用的文字
  cancel:'取消',
  confirm:'确认',
  save:'保存',
  addtext:'添加文字',
  addimg:'添加图片',
  modify_information:'修改资料',
  wechat_share:'用微信扫一扫，进入页面后按提示在微信右上角分享到朋友圈或者朋友',
  delete:'删除',
  has_chosen:'已选择：',
  has_chosen2:'个',
  select:'请选择',
  select_img:'选择本地图片',
  suggest:'建议上传720*480的图片，大小不超过5M',
  suggest2:'建议上传720*480的图片，大小不超过5M',
  yuan:'元',
  yuanperhour:'元/小时',
  //关于班级的相关字段（新建、修改、班级信息）
  bj_mode:'上课模式：',
  bj_select:'请选择',
  bj_name:'班级名称：',
  bj_words:'10字以内',
  bj_type:'班级类型：',
  bj_free:'试听班',
  bj_charge:'收费班',
  bj_startdate:'开课日期：',
  bj_time:'上课时间：',
  bj_time2:'上课时间：',       //用在班级成员处
  bj_period:'课程周期：',
  bj_number:'课程次数：',
  bj_price:'试听原价：',
  bj_yuan:'元/小时',
  bj_unitprice:'课程单价',
  bj_setdiscount:'设置优惠',
  bj_discount:'我要优惠：',
  bj_discount2:'优惠',      //用在班级信息里
  bj_yuan2:'元',
  bj_fee:'报名费：',
  bj_free_text:'免费',
  bj_orginal_price:'原价：',
  bj_introduce:'班级介绍:',

  //管理后台左侧导航（SideNav）
  sidenav_wxht: '网校后台',
  sidenav_kclb: '课程列表',
  sidenav_ddgl: '订单管理',
  sidenav_tjjs: '统计结算',
  sidenav_yxhd: '营销活动',
  sidenav_grzx: '个人中心',
  //网校后台顶部导航
  school_wxht:'网校后台',
  school_wxcy:'网校成员',
  school_wxsz:'网校设置',
  //网校后台——网校后台——课件管理
  school_a_goback:'返回上一页',
  school_a_ke:'课',
  school_a_course:'课程',
  school_a_class:'班级：',
  school_a_time:'上课时间：',
  school_a_add_courseware:'添加课件',
  school_a_courseware_cover:'课件封面',
  school_a_courseware_name:'课件名称',
  school_a_courseware_introduce:'课件介绍',
  school_a_courseware_operate:'课件操作',
  school_a_select_courseware:'选择课件',
  school_a_new_courseware:'制作新课件',
  //网校后台——网校成员
  school_m_admin_list:'管理员列表',
  school_m_founder:'创建者',
  school_m_administrator:'管理员',
  school_m_teacher_list:'老师列表',
  school_m_invite_teacher:'邀请老师',
  school_m_score:'综合得分：',
  school_m_opetate:'操作',
  school_m_set_administrator:'授权为管理员',
  school_m_modify_information:'修改资料',
  school_m_delete_teacher:'删除老师',
  school_m_invite_admin:'邀请管理员',
  school_m_settobe_admin:'设置校内老师为管理员',
  school_m_chose:'已选择：',
  school_m_chose2:'人',
  school_m_avatar:'设置头像：',
  school_m_name:'设置姓名：',
  school_m_sex:'选择性别：',
  school_m_type:'课程分类：',
  school_m_personal_introduce:'个人介绍：',
  //网校后台——网校设置
  school_s_basic_information:'网校基本资料',
  school_s_system:'体系：',
  school_s_modify:'修改资料',
  school_s_introduce:'网校介绍',
  school_s_modify_data:'修改资料',
  school_s_avatar:'网校头像：',
  school_s_name:'网校名称：',
  school_s_type:'网校类型',
  school_s_introduce2:'网校介绍：',
  school_s_addtext:'添加文字',
  school_s_addimg:'添加图片',
  //课程列表
  cou_n_new_course:'新建课程',
  cou_n_course_title:'课程标题：',
  cou_n_course_type:'课程分类：',
  cou_n_course_cover:'课程封面：',
  cou_n_course_introduce:'课程介绍：',
  cou_n_course_input_title:'请填写课程标题',
  cou_n_gong:'共',
  cou_n_gong2:'人参与',
  //课程列表——班级管理
  cou_top_bjgl:'班级管理',
  cou_top_kjgl:'课件/备课',
  cou_top_kcb:'课程表',
  cou_top_kcyhq:'课程优惠券',
  class_add_teacher:'添加授课老师',
  class_modify_course:'修改课程',
  class_share_course:'分享课程',
  class_preview:'预览',
      //预览课程弹窗(除了标题不一样外，其余文字部分同新建课程中的部分)
  class_pre_sectionTitle:'预览课程',
      //修改课程弹窗(除了标题不一样外，其余文字部分同新建课程中的部分)
  class_modify_sectionTitle:'修改课程',
      //分享课程弹窗
  class_share_sectionTitle:'分享课程',
      //添加授课老师弹窗
  class_addteacher_sectionTitle:'选择校内老师',
  class_addteacher_teacherNow:'当前课程老师为：',
  class_addteacher_inviteTeacher:'邀请校外老师',
      //邀请老师弹窗
  class_inviteteacher_sectionTitle:'邀请老师',

  class_more:'更多',
      //视频录制
  class_makedemovideo:'课程试听录制',
  class_v_step1:'1.设置录制时间',
  class_v_minute:'分钟',
  class_v_hint:'建议在5~15分钟内完成录制，请合理安排上课时间',
  class_v_step2:'2.选择录制课件',
  class_v_hint2:'请选择课件，若无课件，请前往“课件管理”添加',
  class_v_step3:'3.课程试听录制',
  class_v_gomake:'去录制',
  class_v_next:'下一步',
  class_v_preview:'试听预览',
  class_v_notSatisfied1:'录制效果不满意？请点击',
  class_v_notSatisfied2:'重新录制',
  class_v_upload:'完成并上传至课程',


  class_new_class:'创建班级',
  class_modify_class:'修改班级',
  class_free_class:'试听班',
  class_enroll:'',
  class_enroll2:'人报名',
  class_time:'时间：',
  class_classinfo:'班级详情',
  class_openlive:'打开直播课表',
  class_startsell:'开始招生',
  class_stopsell:'停止招生',
  class_delete:'删除',
  class_modify:'修改',
  class_share:'分享',
  class_copy:'复制',
      //分享班级弹窗
  class_share_text:'分享班级',
      //删除班级弹窗
  class_delete_text:'确定要删除这个班级吗？',
      //班级下架弹窗
  class_offsell_text:'班级下架后将取消招生，确定要下架这个班级吗？',
  class_numbers1:'共',
  class_numbers2:'课；',

  //班级管理——班级信息
  class_details:'班级信息',
  class_schedule:'课程表',
  class_member:'班级成员',
  class_coupon:'班级优惠券',
  class_back:'返回班级列表',

  //班级管理——班级成员
  class_mem_list:'学员名单（共',
  class_mem_list2:'人）',
  class_mem_noresult:'暂无学员报名，请继续加油哦~',
  class_mem_haspayed:'已支付：',
  class_mem_registration_time:'报名时间：',        //同订单管理的报名时间（此项由冒号）
  class_mem_showall:'显示全部',
  class_mem_search:'选择时间查找',
  class_mem_search_text:'查询',
  //班级管理——优惠券(其余部分参考营销活动——优惠券)
  class_cou_add_coupon:'添加班级优惠券',
  class_cou_sub_explain:'班级优惠券仅适用于当前班级',

  //课程列表——课程优惠券
  cou_cou_explain_title:'课程优惠券说明',
  cou_cou_explain_1:'1、当前功能支持添加多张课程优惠券，优惠券金额需大于0元，可当现金支付抵用。',
  cou_cou_explain_2:'2、课程优惠券适用于当前课程已上架的所有班级报名使用。',
  cou_cou_explain_3:'3、优惠券需设置总张数，支持多次分享或转发，直至领完为止。',
  cou_cou_addcoupon:'添加课程优惠券',
  cou_cou_sub_explain_title:'课程优惠券适用于当前课程的所有班级。',

  //课程列表——课件/备课
  cou_ware_addware:'添加课件',
  cou_ware_btn1:'在线制作课件',
  cou_ware_btn2:'上传PDF文件',
  cou_ware_preview:'预览',
  cou_ware_edit:'编辑',
  cou_ware_createtime:'创建时间：',
  cou_ware_makecourseware:'制作课件',
  cou_ware_title:'课件标题：',
  cou_ware_cover:'课件封面：',
  cou_ware_introduce:'课件介绍：',


  //统计结算--课程结算
  sta_b_bmtj:'课程结算',
  sta_b_kcjs:'报名统计',
  sta_b_yjzsr:'预计总收入（元）',
  sta_b_ktx:'可提现（元）',
  sta_b_sqtx:'申请提现',
  sta_b_ydjsje:'待结算金额',
  sta_b_period:'',
  sta_b_ljtxje:'累计提现总额',
  sta_b_zje:'总金额（元）',
  sta_b_cktxjl:'查看提现记录',
  sta_b_wdzh:'我的账户',
  sta_b_bdzfb:'请绑定支付宝账户：',
  sta_b_srzfb:'请输入支付宝账号',
  sta_b_xmzfb:'支付宝账户姓名：',
  sta_b_srzfbxm:'请输入账号姓名',      //通用
  sta_b_bdwx:'请绑定微信账户：',
  sta_b_srwx:'请输入微信账号',
  sta_b_xmwx:'微信账户姓名：',
  sta_b_msbd:'马上绑定',
  sta_b_bdwxzh:'绑定微信账号',
  sta_b_bdzfbzh:'绑定支付宝账号',
  sta_b_aliaccount:'已绑定支付宝账号：',
  sta_b_wechatccount:'已绑定微信账号：',
  sta_b_xgbd:'修改绑定',
  sta_b_explain1:'财务结算问题说明：',
  sta_b_explain2:'1、每月5日左右结算上个月老师的收入；',
  sta_b_explain3:'2、建议您绑定支付宝帐号，我司通过人工审核汇款至您的个人账户中。',
  sta_b_jsjlcx:'结算记录查询',
  sta_b_zzsk:'正在上课的班级',
  sta_b_yjs:'已结课的班级',
  sta_b_bjxx:'班级信息',
  sta_b_xxrs:'学习人数/人',
  sta_b_sksj:'上课时间',
  sta_b_yjsr:'预计收入',
  sta_b_dqskjd:'当前上课进度',
  sta_b_dqjsje:'当前结算金额',
  sta_b_ywc:'已完成',
  sta_b_times:'次课',
  sta_b_ckxx:'查看详细',
  //统计结算--报名统计
  sta_r_kcbam:'课程报名统计',
  sta_r_xzkc:'选择课程查询：',
  sta_r_kcrq:'开课日期：',
  sta_r_kczq:'开课周期：',
  sta_r_bmrs:'报名人数/人：',
  sta_r_sr:'收入/元：',
  //营销活动——优惠券
  act_c_coupon:'优惠券',
  act_c_explain1:'营销活动说明',
  act_c_explain2:'1、当前功能仅支持添加网校优惠券，课程优惠券和班级优惠券请到对应详情页添加。',
  act_c_explain3:'2、优惠券金额需大于0元，可当现金支付抵用。',
  act_c_explain4:'3、优惠券需设置总张数，支持多次分享或转发，直至领完为止。',
  act_c_addcoupon:'添加网校优惠券',
  act_c_ongoing:'正在进行',
  act_c_history:'历史活动',
  act_c_class_coupon:'班级优惠券：',
  act_c_course_coupon:'课程优惠券：',
  act_c_school_coupon:'网校优惠券：',
  act_c_yuan:'元券',
  act_c_creattime:'创建时间：',
  act_c_coupon_school_explain:'适用于当前网校的所有课程和班级',
  act_c_coupon_course_explain1:'仅适用于',
  act_c_coupon_course_explain2:'课程下的所有班级',
  act_c_coupon_class_explain1:'仅适用于',
  act_c_coupon_class_explain2:'课程下的',
  act_c_coupon_class_explain3:'班级',
  act_c_total_quantity:'发放总数：共',
  act_c_total_ticket:'张',
  act_c_receive:'领取数量：已领',
  act_c_deadline:'优惠截止：',
  act_c_share:'分享优惠券',
  act_c_explain_school:'网校优惠券适用于当前网校的所有课程和班级。',
  act_c_yhje:'优惠金额：',
  act_c_minus:'减',
  act_c_yuan2:'元',
  act_c_number:'优惠券数量：',
  act_c_gong:'共',
  act_c_zhang:'张',
  act_c_deadline2:'优惠截止日：',
  act_c_cancel:'取消',
  act_c_confirm:'确定',
  act_c_share_coupon:'分享优惠券',
  act_c_share_explain:'用微信扫一扫，进入页面后按提示在微信右上角分享到朋友圈或者朋友',
  //订单管理——所有订单
  ord_a_all:'所有订单',
  ord_a_search_date:'订单日期查询：',
  ord_a_search_startdate:'开始日期',
  ord_a_search_enddate:'结束日期',
  ord_a_search_phone:'搜索手机号',
  ord_a_noresult:'暂无搜索结果',
  ord_a_registration_time:'报名时间',
  ord_a_name:'姓名',
  ord_a_phone:'电话',
  ord_a_course:'课程',
  ord_a_class:'班级',
  ord_a_pay:'已支付',
  ord_a_details:'订单详细：',
  ord_a_order_number:'订单号：',
  ord_a_order_cancel:'取消订单申请',
  ord_a_opentime:'开课时间：',
  ord_a_totalnumber:'总课程：共',
  ord_a_totalnumber2:'课',
  ord_a_period:'课程周期：',









};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js